import React, { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import BrandsSection from '../components/site/BrandsSection';
import ContactSection from '../components/site/ContactSection';
import DisciplinesSection from '../components/site/DisciplinesSection';
import HeroSection from '../components/site/HeroSection';
import IntroSection from '../components/site/IntroSection';
import RichardSection from '../components/site/RichardSection';
import ScheduleSection from '../components/site/ScheduleSection';
import TherapiesSection from '../components/site/TherapiesSection';

const imgBase = '/images/';

const HomePage = () => {
  const location = useLocation();
  const [currentHero, setCurrentHero] = useState(0);

  const heroImages = useMemo(
    () => [
      `${imgBase}dojo/1742061539350.jpg`,
      `${imgBase}dojo/1742061539381.jpg`,
      `${imgBase}dojo/1742061611615.jpg`,
      `${imgBase}dojo/1742061611635.jpg`,
      `${imgBase}dojo/1742061611654.jpg`,
      `${imgBase}dojo/1742061611679.jpg`,
      `${imgBase}dojo/1742061611700.jpg`,
      `${imgBase}dojo/1742061611720.jpg`,
      `${imgBase}dojo/1742061611743.jpg`,
      `${imgBase}dojo/1742061611759.jpg`
    ],
    []
  );

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentHero((prev) => (prev + 1) % heroImages.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [heroImages.length]);

  useEffect(() => {
    const raw = location.hash?.replace(/^#/, '');
    if (!raw) return;
    const el = document.getElementById(raw);
    if (el) requestAnimationFrame(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }));
  }, [location.hash, location.pathname]);

  return (
    <>
      <HeroSection
        currentHero={currentHero}
        heroImages={heroImages}
        imgBase={imgBase}
        setCurrentHero={setCurrentHero}
      />
      <IntroSection />
      <BrandsSection imgBase={imgBase} />
      <DisciplinesSection />
      <RichardSection />
      <TherapiesSection imgBase={imgBase} />
      <ScheduleSection />
      <ContactSection />
    </>
  );
};

export default HomePage;
